import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class HelperService {
	renewalPaymentDetails:any;
	[x: string]: any;

	// function to convert current time of any time zone into current time of indian time zone.
	istTime(date: any) {
		let ISTOffset = 330;   // IST offset UTC +5:30 
		let currentDate = new Date(date);
		let currentOffset = currentDate.getTimezoneOffset();
		// console.log('current offset ', currentOffset)
		let exactSessionDate = new Date(currentDate.getTime() + (ISTOffset + currentOffset) * 60000);
		return exactSessionDate;
	}

	// function to get the exact session date aacording to IST while retrieving data from db.
	istTime2(date) {
		let currentDate = new Date(date);

		let localSessionDateString = currentDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })

		const sessionDateAndTimePart = localSessionDateString.split(',');
		const sessionDateParts = sessionDateAndTimePart[0].split('/');

		// converting sessionDate according to IST
		let sessionyear = parseInt(sessionDateParts[2], 10);
		let sessionmonth = parseInt(sessionDateParts[0], 10);
		sessionmonth -= 1;
		let sessiondayCount = parseInt(sessionDateParts[1], 10);

		// This will be the exact session date time as IST.
		const localSessionDate = new Date(sessionyear, sessionmonth, sessiondayCount, 0, 0, 0);

		return localSessionDate;
	}

	// function to set date and time inputs according to IST.
	istTime3(date: any, endHour, endMinute) {
		let currentDate = new Date(date);
		let sessionEndHour: any = endHour;
		let sessionEndMinute: any = endMinute;

		let ISTOffset = -330;  // IST offset UTC +5:30 
		let currentOffset = currentDate.getTimezoneOffset();
		let minuteDifference = ISTOffset - currentOffset
		let absoluteMinuteDifference = Math.abs(minuteDifference)

		let hour = Math.floor(absoluteMinuteDifference / 60);
		let minute = absoluteMinuteDifference % 60;

		if (minuteDifference > 0) {
			sessionEndHour += hour;
			sessionEndMinute += minute;
		} else if (minuteDifference < 0) {
			sessionEndHour -= hour;
			sessionEndMinute -= minute;
		}

		let exactSessionDate = new Date(currentDate);
		exactSessionDate.setHours(sessionEndHour, sessionEndMinute, 0, 0)
		return exactSessionDate;
	}


	getMondayInMiliSeconds(date:any) {
		const newDate = new Date(date);
		console.log(newDate,"newDAte");
		const currentDay = newDate.getUTCDay();
		console.log(currentDay,"currentDay")
		const offset = (currentDay === 0 ? -1 : currentDay - 1); // Calculate days to Monday
	  
		newDate.setUTCHours(0, 0, 0, 0); // Set time to 12:00 AM
		newDate.setUTCDate(newDate.getUTCDate() - offset); // Set the date to the Monday of the current week
		console.log(newDate,"newDate",newDate.getTime());
		return newDate.getTime();
	  }
	  
	 
	 

	  

	// getMondayInMiliSeconds ( date:any ) {	
	// 	let newDate=new Date(date);
	// 	console.log(date,"date" ,newDate.getDay());
	// 	const day = newDate.getDay() || 7;
	// 	console.log(day,"day",-24 * (day-2));
		
	// 	if (day !== 1) {
	// 		newDate.setHours(-24 * (day-2));	
	// 	}
	// 	else{
	// 		newDate.setHours(24 * (day));
			
	// 	}
	// 	console.log(newDate,"newDate $$$$$");
		
	// 	newDate.setUTCHours(0, 0, 0, 0);
	// 	console.log(newDate,"newDate after");

	// 	return newDate.getTime();
	//   };

	get parentCancellationAndReschedulingReason() {
		let reasons = ["Child is unavailable", "Academic commitments", "Technical difficulties",
			"Running late", "Medical emergency", "Personal emergency", "Out of town"]
		return reasons;
	}

	get expertCancellationAndReschedulingReason() {
		let reasons = ["Technical difficulties", "Personal emergency", "Medical emergency",
			"On leave"]
		return reasons;
	}

	get languages() {
		var languages = ["English", "Hindi", "Marathi", "Gujarati", "Telugu", "Tamil", "Kannada", "Malayalam", "Bengali", "Manipuri", "Odiya", "Haryanvi", "Marwari", "Tulu", "Dogri", "Santali", "Assamese", "Maithili", "Kashmiri", "Sindhi", "Konkani", "Rajasthani", "Urdu", "Punjabi", "Nepali"]
		languages.sort();
		languages.push("Others");
		return languages;
	}

	get genders() {
		let genders = ["Male", "Female"]
		return genders;
	}

	get sessionActivationStatus() {
		let sessions = ["Both Enabled", "Consultation Disabled", "Session Disabled", "Session & Consultation Disabled"]
		return sessions;
	}

	get parentStatus() {
		let status = ["Active", "Inactive", "Invited", "Renewal"]
		return status;
	}


	get parentActivityStatus() {
		let status = ["Active", "Inactive"]
		return status;
	}

	get sessionTypes(): string[] {
		let sessionTypes = ["Scheduled", "Rescheduled", "Cancelled", "Session Request", "Starting", "Expert Joined",
			"Parent Joined", "Ongoing", "Partially Attended", "Attended", "No show by parent", "No show by expert"]
		return sessionTypes;
	}

	get sessionTypesObject(): object[] {
		let obj = [{ name: "Scheduled" }, { name: "Rescheduled" }, { name: "Cancelled" }, { name: "Session Request" }, { name: "Starting" },
		{ name: "Expert Joined" }, { name: "Parent Joined" }, { name: "Ongoing" }, { name: "Partially Attended" }, { name: "Attended" },
		{ name: "No show by parent" }, { name: "No show by expert" }];
		return obj;
	}

	get consultationTypes() {
		let consultationTypes = ["Paid Consultation", "Free Consultation"]
		return consultationTypes;
	}

	// get services():string[]{
	// 	var services = ["General Consultation","Screening","Assessment","Parent Counselling","Remedial Session","Family Training","Developmental Psychology","Sensory Integration","Special Education - STEM","Vocational Training","Early Intervention","Psychotherapy","Adaptive Behavior Analysis","Speech Therapy","Braille Literacy","O&M","Art Therapy","Behaviour Analysis & Support","Occupational Therapy", "Other"]
	// 	return services;
	// }

	get services(): string[] {
		var services = ["Parent Counselling", "Remedial Intervention", "Family Training", "Special Education - STEM", "Behavior Therapy", "Speech Therapy", "Child Counselling", "Formal Assessments", "Occupational Therapy", "Public Speaking Class", "Other"]
		return services;
	}

	get ageGroups(): string[] {
		var ageGroups = ["0-2", "2-6", "6-12", "12-15", "15-20", "20+"];
		return ageGroups;
	}

	get numbers() {
		let numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
		return numbers;
	}

	get expertConditions(): string[] {
		var conditions = ["Hearing Impairment", "Speech Delay", "Dysarthria", "Orofacial Myofunctional Disorders (OMD)", "Speech Sound Disorders", "Stuttering", "Voice Disorders", "Autism Spectrum Disorder (ASD)", "Attention Deficit Hyperactivity Disorder (ADHD)", "Intellectual Disability (ID)", "Mental Retardation (MR)", "Global Developmental Delay", "Down Syndrome (DS)", "Cerebral Palsy (CP)", "Dyslexia", "Dysgraphia", "Dyscalculia", "Spina Bifida", "Slow learning", "Anxiety", "Depression", "Eating Disorders", "OCD", "Trauma-related Disorders", "Disruptive Behaviour Disorders", "Vision Impairment", "Low Vision"];

		conditions.sort();
		conditions.push("Others");

		return conditions;
	}

	get conditions(): string[] {
		var conditions = ["Speech & Communication", "Focus & Attention", "Cognition & Logical thinking", "Self-care/ Activities of daily living", "Social-Emotional Interactions", "Sensory Processing", "Academic Slow Learning", "Physical/Motor Skills", "Other"];
		return conditions;
	}

	get consultationPreferredTimes(): string[] {
		var consultationPreferredTimes = ["09:00 - 11:00 IST", "11:00 - 13:00 IST", "13:00 - 15:00 IST", "15:00 - 17:00 IST", "17:00 - 19:00 IST", "19:00 - 21:00 IST"];
		return consultationPreferredTimes;
	}

	get timeZones(): string[] {
		var timeZones = ['Africa/Abidjan', 'Africa/Accra', 'Africa/Addis_Ababa', 'Africa/Algiers', 'Africa/Asmara', 'Africa/Asmera', 'Africa/Bamako', 'Africa/Bangui', 'Africa/Banjul', 'Africa/Bissau', 'Africa/Blantyre', 'Africa/Brazzaville', 'Africa/Bujumbura', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Ceuta', 'Africa/Conakry', 'Africa/Dakar', 'Africa/Dar_es_Salaam', 'Africa/Djibouti', 'Africa/Douala', 'Africa/El_Aaiun', 'Africa/Freetown', 'Africa/Gaborone', 'Africa/Harare', 'Africa/Johannesburg', 'Africa/Juba', 'Africa/Kampala', 'Africa/Khartoum', 'Africa/Kigali', 'Africa/Kinshasa', 'Africa/Lagos', 'Africa/Libreville', 'Africa/Lome', 'Africa/Luanda', 'Africa/Lubumbashi', 'Africa/Lusaka', 'Africa/Malabo', 'Africa/Maputo', 'Africa/Maseru', 'Africa/Mbabane', 'Africa/Mogadishu', 'Africa/Monrovia', 'Africa/Nairobi', 'Africa/Ndjamena', 'Africa/Niamey', 'Africa/Nouakchott', 'Africa/Ouagadougou', 'Africa/Porto-Novo', 'Africa/Sao_Tome', 'Africa/Timbuktu', 'Africa/Tripoli', 'Africa/Tunis', 'Africa/Windhoek', 'America/Adak', 'America/Anchorage', 'America/Anguilla', 'America/Antigua', 'America/Araguaina', 'America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/ComodRivadavia', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia', 'America/Aruba', 'America/Asuncion', 'America/Atikokan', 'America/Atka', 'America/Bahia', 'America/Bahia_Banderas', 'America/Barbados', 'America/Belem', 'America/Belize', 'America/Blanc-Sablon', 'America/Boa_Vista', 'America/Bogota', 'America/Boise', 'America/Buenos_Aires', 'America/Cambridge_Bay', 'America/Campo_Grande', 'America/Cancun', 'America/Caracas', 'America/Catamarca', 'America/Cayenne', 'America/Cayman', 'America/Chicago', 'America/Chihuahua', 'America/Coral_Harbour', 'America/Cordoba', 'America/Costa_Rica', 'America/Creston', 'America/Cuiaba', 'America/Curacao', 'America/Danmarkshavn', 'America/Dawson', 'America/Dawson_Creek', 'America/Denver', 'America/Detroit', 'America/Dominica', 'America/Edmonton', 'America/Eirunepe', 'America/El_Salvador', 'America/Ensenada', 'America/Fort_Nelson', 'America/Fort_Wayne', 'America/Fortaleza', 'America/Glace_Bay', 'America/Godthab', 'America/Goose_Bay', 'America/Grand_Turk', 'America/Grenada', 'America/Guadeloupe', 'America/Guatemala', 'America/Guayaquil', 'America/Guyana', 'America/Halifax', 'America/Havana', 'America/Hermosillo', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Indianapolis', 'America/Inuvik', 'America/Iqaluit', 'America/Jamaica', 'America/Jujuy', 'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Knox_IN', 'America/Kralendijk', 'America/La_Paz', 'America/Lima', 'America/Los_Angeles', 'America/Louisville', 'America/Lower_Princes', 'America/Maceio', 'America/Managua', 'America/Manaus', 'America/Marigot', 'America/Martinique', 'America/Matamoros', 'America/Mazatlan', 'America/Mendoza', 'America/Menominee', 'America/Merida', 'America/Metlakatla', 'America/Mexico_City', 'America/Miquelon', 'America/Moncton', 'America/Monterrey', 'America/Montevideo', 'America/Montreal', 'America/Montserrat', 'America/Nassau', 'America/New_York', 'America/Nipigon', 'America/Nome', 'America/Noronha', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Ojinaga', 'America/Panama', 'America/Pangnirtung', 'America/Paramaribo', 'America/Phoenix', 'America/Port-au-Prince', 'America/Port_of_Spain', 'America/Porto_Acre', 'America/Porto_Velho', 'America/Puerto_Rico', 'America/Punta_Arenas', 'America/Rainy_River', 'America/Rankin_Inlet', 'America/Recife', 'America/Regina', 'America/Resolute', 'America/Rio_Branco', 'America/Rosario', 'America/Santa_Isabel', 'America/Santarem', 'America/Santiago', 'America/Santo_Domingo', 'America/Sao_Paulo', 'America/Scoresbysund', 'America/Shiprock', 'America/Sitka', 'America/St_Barthelemy', 'America/St_Johns', 'America/St_Kitts', 'America/St_Lucia', 'America/St_Thomas', 'America/St_Vincent', 'America/Swift_Current', 'America/Tegucigalpa', 'America/Thule', 'America/Thunder_Bay', 'America/Tijuana', 'America/Toronto', 'America/Tortola', 'America/Vancouver', 'America/Virgin', 'America/Whitehorse', 'America/Winnipeg', 'America/Yakutat', 'America/Yellowknife', 'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Macquarie', 'Antarctica/Mawson', 'Antarctica/McMurdo', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/South_Pole', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok', 'Arctic/Longyearbyen', 'Asia/Aden', 'Asia/Almaty', 'Asia/Amman', 'Asia/Anadyr', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Ashkhabad', 'Asia/Atyrau', 'Asia/Baghdad', 'Asia/Bahrain', 'Asia/Baku', 'Asia/Bangkok', 'Asia/Barnaul', 'Asia/Beirut', 'Asia/Bishkek', 'Asia/Brunei', 'Asia/Calcutta', 'Asia/Chita', 'Asia/Choibalsan', 'Asia/Chongqing', 'Asia/Chungking', 'Asia/Colombo', 'Asia/Dacca', 'Asia/Damascus', 'Asia/Dhaka', 'Asia/Dili', 'Asia/Dubai', 'Asia/Dushanbe', 'Asia/Famagusta', 'Asia/Gaza', 'Asia/Harbin', 'Asia/Hebron', 'Asia/Ho_Chi_Minh', 'Asia/Hong_Kong', 'Asia/Hovd', 'Asia/Irkutsk', 'Asia/Istanbul', 'Asia/Jakarta', 'Asia/Jayapura', 'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka', 'Asia/Karachi', 'Asia/Kashgar', 'Asia/Kathmandu', 'Asia/Katmandu', 'Asia/Khandyga', 'Asia/Kolkata', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Kuching', 'Asia/Kuwait', 'Asia/Macao', 'Asia/Macau', 'Asia/Magadan', 'Asia/Makassar', 'Asia/Manila', 'Asia/Muscat', 'Asia/Nicosia', 'Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk', 'Asia/Oral', 'Asia/Phnom_Penh', 'Asia/Pontianak', 'Asia/Pyongyang', 'Asia/Qatar', 'Asia/Qostanay', 'Asia/Qyzylorda', 'Asia/Rangoon', 'Asia/Riyadh', 'Asia/Saigon', 'Asia/Sakhalin', 'Asia/Samarkand', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Srednekolymsk', 'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Tel_Aviv', 'Asia/Thimbu', 'Asia/Thimphu', 'Asia/Tokyo', 'Asia/Tomsk', 'Asia/Ujung_Pandang', 'Asia/Ulaanbaatar', 'Asia/Ulan_Bator', 'Asia/Urumqi', 'Asia/Ust-Nera', 'Asia/Vientiane', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yangon', 'Asia/Yekaterinburg', 'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Bermuda', 'Atlantic/Canary', 'Atlantic/Cape_Verde', 'Atlantic/Faeroe', 'Atlantic/Faroe', 'Atlantic/Jan_Mayen', 'Atlantic/Madeira', 'Atlantic/Reykjavik', 'Atlantic/South_Georgia', 'Atlantic/St_Helena', 'Atlantic/Stanley', 'Australia/ACT', 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Broken_Hill', 'Australia/Canberra', 'Australia/Currie', 'Australia/Darwin', 'Australia/Eucla', 'Australia/Hobart', 'Australia/LHI', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne', 'Australia/NSW', 'Australia/North', 'Australia/Perth', 'Australia/Queensland', 'Australia/South', 'Australia/Sydney', 'Australia/Tasmania', 'Australia/Victoria', 'Australia/West', 'Australia/Yancowinna', 'Brazil/Acre', 'Brazil/DeNoronha', 'Brazil/East', 'Brazil/West', 'CET', 'CST6CDT', 'Canada/Atlantic', 'Canada/Central', 'Canada/Eastern', 'Canada/Mountain', 'Canada/Newfoundland', 'Canada/Pacific', 'Canada/Saskatchewan', 'Canada/Yukon', 'Chile/Continental', 'Chile/EasterIsland', 'Cuba', 'EET', 'EST5EDT', 'Egypt', 'Eire', 'Etc/GMT', 'Etc/GMT+0', 'Etc/GMT+1', 'Etc/GMT+10', 'Etc/GMT+11', 'Etc/GMT+12', 'Etc/GMT+2', 'Etc/GMT+3', 'Etc/GMT+4', 'Etc/GMT+5', 'Etc/GMT+6', 'Etc/GMT+7', 'Etc/GMT+8', 'Etc/GMT+9', 'Etc/GMT-0', 'Etc/GMT-1', 'Etc/GMT-10', 'Etc/GMT-11', 'Etc/GMT-12', 'Etc/GMT-13', 'Etc/GMT-14', 'Etc/GMT-2', 'Etc/GMT-3', 'Etc/GMT-4', 'Etc/GMT-5', 'Etc/GMT-6', 'Etc/GMT-7', 'Etc/GMT-8', 'Etc/GMT-9', 'Etc/GMT0', 'Etc/Greenwich', 'Etc/UCT', 'Etc/UTC', 'Etc/Universal', 'Etc/Zulu', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Astrakhan', 'Europe/Athens', 'Europe/Belfast', 'Europe/Belgrade', 'Europe/Berlin', 'Europe/Bratislava', 'Europe/Brussels', 'Europe/Bucharest', 'Europe/Budapest', 'Europe/Busingen', 'Europe/Chisinau', 'Europe/Copenhagen', 'Europe/Dublin', 'Europe/Gibraltar', 'Europe/Guernsey', 'Europe/Helsinki', 'Europe/Isle_of_Man', 'Europe/Istanbul', 'Europe/Jersey', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Kirov', 'Europe/Lisbon', 'Europe/Ljubljana', 'Europe/London', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Mariehamn', 'Europe/Minsk', 'Europe/Monaco', 'Europe/Moscow', 'Europe/Nicosia', 'Europe/Oslo', 'Europe/Paris', 'Europe/Podgorica', 'Europe/Prague', 'Europe/Riga', 'Europe/Rome', 'Europe/Samara', 'Europe/San_Marino', 'Europe/Sarajevo', 'Europe/Saratov', 'Europe/Simferopol', 'Europe/Skopje', 'Europe/Sofia', 'Europe/Stockholm', 'Europe/Tallinn', 'Europe/Tirane', 'Europe/Tiraspol', 'Europe/Ulyanovsk', 'Europe/Uzhgorod', 'Europe/Vaduz', 'Europe/Vatican', 'Europe/Vienna', 'Europe/Vilnius', 'Europe/Volgograd', 'Europe/Warsaw', 'Europe/Zagreb', 'Europe/Zaporozhye', 'Europe/Zurich', 'GB', 'GB-Eire', 'GMT', 'GMT0', 'Greenwich', 'Hongkong', 'Iceland', 'Indian/Antananarivo', 'Indian/Chagos', 'Indian/Christmas', 'Indian/Cocos', 'Indian/Comoro', 'Indian/Kerguelen', 'Indian/Mahe', 'Indian/Maldives', 'Indian/Mauritius', 'Indian/Mayotte', 'Indian/Reunion', 'Iran', 'Israel', 'Jamaica', 'Japan', 'Kwajalein', 'Libya', 'MET', 'MST7MDT', 'Mexico/BajaNorte', 'Mexico/BajaSur', 'Mexico/General', 'NZ', 'NZ-CHAT', 'Navajo', 'PRC', 'PST8PDT', 'Pacific/Apia', 'Pacific/Auckland', 'Pacific/Bougainville', 'Pacific/Chatham', 'Pacific/Chuuk', 'Pacific/Easter', 'Pacific/Efate', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Fiji', 'Pacific/Funafuti', 'Pacific/Galapagos', 'Pacific/Gambier', 'Pacific/Guadalcanal', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Johnston', 'Pacific/Kiritimati', 'Pacific/Kosrae', 'Pacific/Kwajalein', 'Pacific/Majuro', 'Pacific/Marquesas', 'Pacific/Midway', 'Pacific/Nauru', 'Pacific/Niue', 'Pacific/Norfolk', 'Pacific/Noumea', 'Pacific/Pago_Pago', 'Pacific/Palau', 'Pacific/Pitcairn', 'Pacific/Pohnpei', 'Pacific/Ponape', 'Pacific/Port_Moresby', 'Pacific/Rarotonga', 'Pacific/Saipan', 'Pacific/Samoa', 'Pacific/Tahiti', 'Pacific/Tarawa', 'Pacific/Tongatapu', 'Pacific/Truk', 'Pacific/Wake', 'Pacific/Wallis', 'Pacific/Yap', 'Poland', 'Portugal', 'ROK', 'Singapore', 'SystemV/AST4', 'SystemV/AST4ADT', 'SystemV/CST6', 'SystemV/CST6CDT', 'SystemV/EST5', 'SystemV/EST5EDT', 'SystemV/HST10', 'SystemV/MST7', 'SystemV/MST7MDT', 'SystemV/PST8', 'SystemV/PST8PDT', 'SystemV/YST9', 'SystemV/YST9YDT', 'Turkey', 'UCT', 'US/Alaska', 'US/Aleutian', 'US/Arizona', 'US/Central', 'US/East-Indiana', 'US/Eastern', 'US/Hawaii', 'US/Indiana-Starke', 'US/Michigan', 'US/Mountain', 'US/Pacific', 'US/Pacific-New', 'US/Samoa', 'UTC', 'Universal', 'W-SU', 'WET', 'Zulu'];
		return timeZones;
	}

	uuidv4() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	// getEndTime(session: any): string{
	//   if(session.slotDuration === 60){
	//     let time = session.endTime.split(':');
	//     if(time[1] === "00"){
	//       let newHour = +time[0] - 1;
	//       if(time[0] == "0" || time[0] == "00")
	//         newHour = 23;
	//     return `${newHour}:50`;
	//     } else if(time[1] === "30")
	//     return `${time[0]}:20`;
	//   } else return session.endTime;
	// }

	getEndTime(session: any): string {
		let time = session.endTime.split(':');
		let minutes = +time[1];
		let hours = +time[0];
		if ((minutes - 10) > 0) {
			if ((minutes - 10) < 10) {
				return `${time[0]}:0${minutes - 10}`
			} else {
				return `${time[0]}:${minutes - 10}`
			}
		} else if ((minutes - 10) == 0) {
			return `${time[0]}:00`;
		} else if ((minutes - 10) < 0) {
			hours--;
			if (hours < 0)
				hours = 23;
			minutes = 50 + minutes;
			return `${hours}:${minutes}`;
		}
	}
    subtractDays(days: number, fromDate: Date = new Date()): Date {
		return new Date(fromDate.getTime() - (days * 24 * 60 * 60 * 1000));
	}

	get days(): string[] {
		var days = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday","Saturday"];
		return days;
	}
}